import React from 'react';
import PropTypes from 'prop-types';
import Select from "react-select";
import AutosuggestInput from '@components/common/autosuggest_input/main';

class CustomFieldsInputRow extends React.Component {
  state = {
    stagedKey: this.setDefaultKey(),
    stagedValue: null
  }

  setDefaultKey() {
    return this.props.controlledFields
      ? this.existingCustomFieldKeyNames()[this.props.position]
      : null;
  }

  updateKey = (selection) => {
    const updatedKey = (typeof selection === "object") ? selection.value : selection;
    this.setState({ stagedKey: updatedKey }, this.stageCustomField);
  }

  // ReactSelect requires & returns objects, AutosuggestInput returns string
  updateValue = (selection) => {
    const updatedValue = (typeof selection === "object") ? selection.value : selection;
    this.setState({ stagedValue: updatedValue }, this.stageCustomField);
  }

  getValuesForKey = (key) => {
    if (!key) { return []; }
    if (key.attributes.restricted) { return key.attributes.allowed_values; }
    return [...new Set(key.attributes.values)];
  }

  getKeyByName = (keyName) => this.props.existingCustomFields.find((key) => key.attributes.name === keyName);

  stageCustomField = () => {
    const { stagedKey, stagedValue } = this.state;
    this.props.updateStagedCustomFields(this.props.position, stagedKey, stagedValue);
  }

  // ReactSelect requires & returns objects, AutosuggestInput returns string
  formattedReactSelectKeyOptions = () => {
    const keyName = this.existingCustomFieldKeyNames()[this.props.position];
    return [{ value: keyName, label: keyName }];
  }

  formattedReactSelectValueOptions = () => {
    const { stagedKey } = this.state;
    const matchingKey = this.getKeyByName(stagedKey);
    const values = this.getValuesForKey(matchingKey);
    return values.map((keyName) => ({ value: keyName, label: keyName }));
  }

  existingCustomFieldKeyNames() {
    return this.props.existingCustomFields.map(
      (customField) => customField.attributes.name
    );
  }

  renderKeySelector() {
    if (this.props.controlledFields) {
      return (
        <Select
          className="select-custom-field-key-input"
          closeOnSelect
          options={this.formattedReactSelectKeyOptions()}
          value={this.formattedReactSelectKeyOptions()[0]}
        />
      );
    }
    return (
      <AutosuggestInput
        id="autosuggest-custom-field-key-input"
        options={this.existingCustomFieldKeyNames()}
        changeValue={this.updateKey}
      />
    );
  }

  renderValueSelector() {
    const { stagedKey } = this.state;
    const matchingKey = this.getKeyByName(stagedKey);
    if (this.props.controlledFields && matchingKey.attributes.restricted) {
      return (
        <Select
          className="select-custom-field-value-input"
          closeOnSelect
          onChange={this.updateValue}
          options={this.formattedReactSelectValueOptions()}
          placeholder={t('Value')}
          value={this.state.stagedValue}
        />
      );
    }
    return (
      <AutosuggestInput
        id="autosuggest-custom-field-value-input"
        options={this.getValuesForKey(matchingKey)}
        changeValue={this.updateValue}
      />
    );
  }

  render() {
    return (
      <div className="inputs-row">
        <div className="custom-field-key-input">
          {this.renderKeySelector()}
        </div>
        <div className="custom-field-value-input">
          {this.renderValueSelector()}
        </div>
        <span className="bff-trash" onClick={() => this.props.eliminateRow(this.props.position)} />
      </div>
    );
  }
}

CustomFieldsInputRow.propTypes = {
  existingCustomFields: PropTypes.arrayOf(PropTypes.object).isRequired,
  updateStagedCustomFields: PropTypes.func.isRequired,
  position: PropTypes.number.isRequired,
  eliminateRow: PropTypes.func.isRequired,
  controlledFields: PropTypes.bool.isRequired
};

export default CustomFieldsInputRow;
